export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-6">
          <div>
            <div className="flex-column items-center my-2">
              <div className=''>
                <span className="text-lg md:text-2xl font-bold text-white">ever</span>
                <span className="text-lg md:text-2xl font-bold text-green-400">green</span>
              </div>
              <div className='flex-row'>
                <div className="text-lg md:text-2xl font-bold text-white">growth partners</div>
              </div>

            </div>
            
          </div>
          <div></div>
          <div className="grid grid-cols-2 gap-4 justify-end">
            <div>
              <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-4">Quick Links</h3>
              <div className="space-y-2 text-sm md:text-base">
                <a href="#about" className="block text-gray-400 hover:text-green-400">About Us</a>
                <a href="#services" className="block text-gray-400 hover:text-green-400">Our Services</a>
                <a href="#founder" className="block text-gray-400 hover:text-green-400">About the Founder</a>
                <a href="#contact" className="block text-gray-400 hover:text-green-400">Contact Us</a>
              </div>
            </div>
            <div>
              <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-4">Follow Us</h3>
              <div className="space-y-2 text-sm md:text-base">
                <a href="https://www.linkedin.com/company/evergreen-growth-partners-india/" className="block text-gray-400 hover:text-green-400">LinkedIn</a>
                <a href="https://x.com/tanmayshahh?s=21&t=BAEahm_yFdBFx_342pmf7Q" className="block text-gray-400 hover:text-green-400">X</a>
                {/* <a href="#" className="block text-gray-400 hover:text-green-400">Facebook</a> */}
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-xs md:text-sm">
          <p>&copy; 2025 Evergreen Growth Partners. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};